import NAutocomplete from './NAutocomplete.vue';
export default NAutocomplete;